module.exports = __webpack_public_path__ + "img/1.c5ff3a4d.jpg";